// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2_COS","header":"ReportDetails_header__3SfHK","title":"ReportDetails_title__3oogR","left":"ReportDetails_left__2-Q1C"};